import { isCountryCapturable, isIpCountryCapturable } from '../geo-permission';

const checkoutFrom = (country: string | null) =>
  ({
    id: 'chk_1',
    ip_geo_address: country ? { country } : null,
  }) as any;

describe('isIpCountryCapturable', () => {
  it('captures everywhere when the list is empty', () => {
    expect(isIpCountryCapturable(checkoutFrom('US'), [])).toBe(true);
    expect(isIpCountryCapturable(checkoutFrom(null), [])).toBe(true);
    expect(isIpCountryCapturable(null, [])).toBe(true);
  });

  it('matches when the IP country is listed', () => {
    expect(isIpCountryCapturable(checkoutFrom('IN'), ['IN', 'BR'])).toBe(true);
  });

  it('rejects when the IP country is not listed', () => {
    expect(isIpCountryCapturable(checkoutFrom('US'), ['IN', 'BR'])).toBe(false);
  });

  it('fails closed when the IP country is unknown', () => {
    expect(isIpCountryCapturable(checkoutFrom(null), ['IN'])).toBe(false);
    expect(isIpCountryCapturable(null, ['IN'])).toBe(false);
    // Unexpanded address id, not an object.
    expect(isIpCountryCapturable({ id: 'chk_1', ip_geo_address: 'addr_1' } as any, ['IN'])).toBe(false);
  });
});

describe('isCountryCapturable', () => {
  it('matches case-insensitively', () => {
    expect(isCountryCapturable('us', ['US', 'CA'])).toBe(true);
    expect(isCountryCapturable('US', ['us'])).toBe(true);
  });

  it('captures everywhere when the list is empty', () => {
    expect(isCountryCapturable(null, [])).toBe(true);
  });

  it('fails closed for a missing or unlisted code', () => {
    expect(isCountryCapturable(null, ['US'])).toBe(false);
    expect(isCountryCapturable('FR', ['US'])).toBe(false);
  });
});
